import { Box, Button, DialogContent, Divider, Grid, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'redux';

import { Address as AddressModel } from '../../../../domain/address';
import { AddressView } from '../../../../general/components/address-view';
import { Dialog } from '../../../../general/components/dialog';
import { RootState } from '../../../../store';

const selector = ({ addressLookup: { enteredAddress: originalAddress, suggestedAddress } }: RootState) => ({
  originalAddress,
  suggestedAddress,
});

type AddressChoiceProps = {
  address: AddressModel;
  title: string;
  variant: 'outlined' | 'contained';
  onChoose: () => void;
};
const AddressChoice: React.FC<AddressChoiceProps> = ({ address, title, variant, onChoose }: AddressChoiceProps) => {
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={7}>
        <Typography variant="body2" color="textSecondary" component="div">
          <AddressView address={address} />
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5}>
        <Button color="primary" size="large" variant={variant} onClick={onChoose} fullWidth>
          {title}
        </Button>
      </Grid>
    </Grid>
  );
};

type Props = {
  onClose: () => void;
  context: {
    suggestedAddressActions: Action[];
    originalAddressActions: Action[];
  };
};

const SimilarAddressDlg: React.FC<Props> = ({
  onClose,
  context: { suggestedAddressActions, originalAddressActions },
}: Props) => {
  const { originalAddress, suggestedAddress } = useSelector(selector);

  const dispatch = useDispatch();
  const handleSuggestedClick = useCallback(() => {
    suggestedAddressActions.forEach(dispatch);
    onClose();
  }, [suggestedAddressActions, dispatch, onClose]);

  const handleOriginalClick = useCallback(() => {
    originalAddressActions.forEach(dispatch);
    onClose();
  }, [originalAddressActions, dispatch, onClose]);

  return (
    <Dialog title="We found a similar address to what you provided:" onClose={onClose} fullWidth>
      <DialogContent dividers sx={{ py: 0 }}>
        <Box my={3}>
          <AddressChoice
            address={suggestedAddress!}
            title="Use Suggested Address"
            variant="contained"
            onChoose={handleSuggestedClick}
          />
        </Box>

        <Divider light={false} />

        <Box my={3}>
          <AddressChoice
            address={originalAddress!}
            title="Use Original Address"
            variant="outlined"
            onChoose={handleOriginalClick}
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export { SimilarAddressDlg };
